import { getLogger } from '../../commons/logger';
import type { FrameHandler } from 'clickim/src/locators/dynamicParentUtils';
import type { FrameLocatorInstance } from 'clickim/src/background/frameLocator';

const logger = getLogger('mobile-frame-locator-mock');

/** This is just a mock class hopefully we can remove after we set up types and backwards-compatibility in clickim */
export class FrameLocatorMock implements FrameLocatorInstance {
    foundFrameCallback() {
        logger.info('foundFrameCallback-mock invoked');
        return {};
    }


    locate() {
        logger.info('locate-mock invoked');
        return {};
    }

    async findFrame() {
        logger.info('findFrame-mock invoked');
        return {} as FrameHandler;
    }
}
